import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Button, Typography } from "@ster/ster-toolkit";
import { memo, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { coreApi } from "../../store/coreApi";
import { getToken, logout } from "../../utils";
import SimplePage from "../SimplePage";
import { loginWithRedirect } from "./constants";

const Logout = memo(() => {
  const { i18n } = useLingui();
  const dispatch = useDispatch();

  const gotoLogin = useCallback(() => {
    window.location.href = loginWithRedirect();
  }, []);

  useEffect(() => {
    if (getToken()) {
      logout();
      // Clear the cache, note: hooks are not reset because of redux bug: https://github.com/reduxjs/redux-toolkit/issues/4009
      dispatch(coreApi.util.resetApiState());
    }
  }, [dispatch]);

  return (
    <SimplePage title={i18n._(t`Uitgelogd`)}>
      <Typography.Paragraph>
        <Trans>Je bent uitgelogd.</Trans>
      </Typography.Paragraph>

      <Button onClick={gotoLogin} mode="primary">
        <Trans>Opnieuw inloggen</Trans>
      </Button>
    </SimplePage>
  );
});

export default Logout;
